import { render } from "./DataBaseError.vue?vue&type=template&id=37c628ef"
import script from "./DataBaseError.vue?vue&type=script&lang=js"
export * from "./DataBaseError.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__